import StarRating from "vue-star-rating";
import { mapGetters } from "vuex";

export default {
    name: "BlogProduct",
    props: {
        info: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
           showDropdown: false,
           selectedProductPrice: null
        }
    },
    components: {
        StarRating,
    },
    computed: {
        ...mapGetters({
            currentRegionCurrency: 'regions/currentRegionCurrency',
        })
    },
    created() {
      this.selectedProductPrice = this.info.product.data.productPrices.data[0];
    },
    methods: {
        selectVolume(payload) {
            this.showDropdown = false;
            this.selectedProductPrice = payload;
        },
    }
}
